import { GoogleLogin } from "@react-oauth/google";
import { handleGoogleSignInAuthTokens } from "../../services/apiService";
import { useUser } from "./UserContext";

interface GoogleButtonLoginProps {
  onLogin: () => void;
}

/**
 * Inline Google sign-in button (shown inside the SignInModal).
 *
 * One Tap is handled separately by <GoogleOneTap /> which lives
 * outside the modal so it's never blocked by the backdrop.
 */
const GoogleButtonLogin: React.FC<GoogleButtonLoginProps> = ({ onLogin }) => {
  const { setUser, setToken, setRefreshToken } = useUser();

  const handleSuccess = async (credentialResponse: any) => {
    const result = await handleGoogleSignInAuthTokens(
      credentialResponse.credential
    );
    if (result) {
      setUser(result.user);
      setToken(result.tokens.access_token);
      setRefreshToken(result.tokens.refresh_token);
      onLogin();
    } else {
      console.error("Login failed");
    }
  };

  return (
    <GoogleLogin
      onSuccess={handleSuccess}
      onError={() => console.log("Login Failed")}
    />
  );
};

export default GoogleButtonLogin;
